import signedFetch from '../util/signedFetch.js';

export default (orgId, courseIds) =>
  signedFetch('ngsUpdateMyCourses', `${__API_BASE__}/ngs/org/${orgId}/my-courses`, 'PUT', {
    courseIds
  });
